export default {
  en: "English",
  nb: "Norska (Norwegian)",
  sv: "Svenska (Swedish)",
  da: "Dansk (Danish)",
  fi: "Suomi (Finnish)",
  de: "Deutsch (German)",
  "zh-hans": "中文 (Chinese)",
  es: "Español (Spanish)"
};
